import "./App.css";
import React from "react";
// 设置 antd 为中文
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import Home from "./views/Home/Home";
import LoginPage from "./views/LoginPage/LoginPage";
import { Route, Routes } from "react-router-dom";
import Tasklist from "./components/taskList";
import TaskAppealPage from './views/TaskAppealPage/TaskAppealPage'
import PointsExpandPage from './views/PointsPage/PointsExpandPage'
import PointsMemberPage from './views/PointsPage/PointsMemberPage'
import PointsUserPage from './views/PointsPage/PointsUserPage'
import FinancePage from './views/FinancePage/FinancePage'

dayjs.locale('zh-cn');
const App = () => {
  return (
  <ConfigProvider locale={zhCN}>
    <div className="App">
      {/* <Home /> */}
      {/* <LoginPage /> */}
      <Routes>
        <Route path="/" Component={Home}>
          <Route path='/taskManage/taskList' Component={Tasklist}></Route>
          <Route path='/taskManage/taskAppeal' Component={TaskAppealPage}></Route>
          <Route path='/pointsManage/pointsExpand' Component={PointsExpandPage}></Route>
          <Route path='/pointsManage/pointsMember' Component={PointsMemberPage}></Route>
          <Route path='/pointsManage/pointsUser' Component={PointsUserPage}></Route>
          <Route path='/financeManage/*' Component={FinancePage}></Route>
        </Route>
        <Route path="/login" Component={LoginPage}>
        </Route>
      </Routes>
    </div>
  </ConfigProvider>
  );
};
export default App;
